import React, {Component} from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchUser, logoutUser} from '../actions/firebase_actions';
import DropDownMenu from "./user/dropDownMenu";

class App extends Component {

    constructor(props) {
        super(props);

        this.props.fetchUser();
        this.logOut = this.logOut.bind(this);
    }

    logOut() {
        this.props.logoutUser().then((data) => {
            // reload props from reducer
            this.props.fetchUser();
        });
    }

    renderUserMenu(currentUser) {
        // if current user exists and user id exists than make user navigation
        if (currentUser && currentUser.uid) {
            return (
                <li className="dropdown">
                    <a
                        href="#" className="dropdown-toggle" data-toggle="dropdown" role="button"
                        aria-haspopup="true" aria-expanded="false"
                    >
                        {currentUser.email} <span className="caret"/></a>
                    <DropDownMenu uid={currentUser.uid} logOut={this.logOut}/>
                </li>
            );
        } else {
            return [
                <li key={1}><Link to="/login">Prihlásenie</Link></li>,
                <li key={2}><Link to="/register">Registrácia</Link></li>,
            ];
        }
    }

    render() {
        // <li><Link to="/"> Home</Link></li>
        return (
            <div>
                <header className="navbar navbar-static-top navbar-inverse" id="top" role="banner">
                    <div className="container">
                        <div className="navbar-header">
                            <button
                                className="navbar-toggle collapsed" type="button" data-toggle="collapse"
                                data-target=".bs-navbar-collapse"
                            ><span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"/>
                                <span className="icon-bar"/>
                                <span className="icon-bar"/>
                            </button>
                            <Link to="/profile" className="navbar-brand">Jazda v Bratislave</Link>

                        </div>
                        <nav className="collapse navbar-collapse bs-navbar-collapse" role="navigation">
                            <ul className="nav navbar-nav">
                                <li><Link to="/driver-profile"> Moje údaje</Link></li>
                            </ul>
                            <ul className="nav navbar-nav navbar-right">
                                { this.renderUserMenu(this.props.currentUser) }
                            </ul>
                        </nav>
                    </div>
                </header>

                <div className="container">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({fetchUser, logoutUser}, dispatch);
}


function mapStateToProps(state) {
    return {currentUser: state.currentUser};
}


export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/app/components/app.jsx